import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDivisionIns = async (credentials, data) => {
    const body = {
        service: "RNHDivisionIns",
        params: {
            rnhDivisionCod: data?.cod || null,
            rnhDivisionNombre: data?.name || null,
            rnhDivisionDescripcion: data?.desc || null,
            rnhDepartamentoId: data?.dptoId || null,
            // Los dos permisos de la reparticion. "Y"/"N", como el resto de las
            // banderas del modulo. Con `|| null` porque las dos son strings truthy: si
            // el modal los manda viaja el valor, y si todavia no los manda viaja null,
            // que para estos servicios es "no informado".
            rnhDivisionAdmiteRotativos: data?.admiteRotativos || null,
            rnhDivisionAdmiteGuardias: data?.admiteGuardias || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
